import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { checkPermission } from '../../utils/permissions';

interface BottomNavProps {
  role: string;
}

export const BottomNav = ({ role }: BottomNavProps) => {
  const [isHidden, setIsHidden] = useState(false);
  const isSuperAdmin = role === 'superadmin';

  const items = [
    { label: 'Accueil', icon: 'ri-dashboard-2-line', path: '/dashboard' },
    { label: 'Production', icon: 'ri-refresh-line', path: '/production', permission: 'dash_atelier' },
    { label: 'Nouvelle', icon: 'ri-add-circle-fill', path: '/commande/nouvelle', permission: 'cmd_creer', primary: true },
    { label: 'Ventes', icon: 'ri-shopping-cart-2-line', path: '/vente-tissu', permission: 'vente_creer' },
    { label: 'Menu', icon: 'ri-grid-fill', path: '#', isMenuTrigger: true },
  ];

  // filtrer les items selon les permissions
  const visibleItems = items.filter(item => {
    if (item.isMenuTrigger) return true;
    if (isSuperAdmin) return true;
    if (item.permission) return checkPermission(item.permission);
    return true;
  });

  return (
    <>
      {/* Bouton de rappel quand la barre est masquée */}
      {isHidden && (
        <button 
          onClick={() => setIsHidden(false)}
          title="Afficher la barre"
          className="md:hidden fixed bottom-4 right-4 w-10 h-10 bg-foret-600 text-white rounded-full shadow-lg z-[101] flex items-center justify-center animate-bounce duration-1000"
        >
          <i className="ri-arrow-up-s-line text-xl" />
        </button>
      )}

      <nav className={`md:hidden fixed bottom-0 left-0 right-0 bg-white/95 border-t border-gray-100 px-2 py-1 z-[100] flex items-center justify-around pb-safe shadow-[0_-8px_30px_rgba(0,0,0,0.08)] backdrop-blur-md transition-transform duration-300 ${isHidden ? 'translate-y-full' : 'translate-y-0'}`}>
        {/* Toggle Button */}
        <button 
          onClick={() => setIsHidden(true)}
          title="Masquer la barre"
          className="absolute -top-6 right-4 bg-white/90 border border-gray-100 border-b-0 rounded-t-lg px-2 py-0.5 text-gray-400 text-xs flex items-center gap-1 shadow-sm transition-opacity hover:opacity-100 opacity-70"
        >
          <i className="ri-arrow-down-s-line" />
          Masquer
        </button>
      {visibleItems.map((item, idx) => (
        item.isMenuTrigger ? (
           <button 
             key={idx}
             title="Menu complet"
             onClick={() => {
               if (typeof (window as any).toggleMobileMenu === 'function') {
                 (window as any).toggleMobileMenu();
               }
             }}
             className="flex flex-col items-center justify-center py-1 px-3 text-gray-400 active:text-foret-600 transition-colors"
           >
             <i className={`${item.icon} text-xl`} />
             <span className="text-[10px] font-medium mt-0.5">{item.label}</span>
           </button>
        ) : (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `
              flex flex-col items-center justify-center py-1 px-3 transition-colors relative
              ${item.primary ? 'mb-8' : ''}
              ${isActive ? 'text-foret-600' : 'text-gray-400'}
            `}
          >
            {item.primary ? (
              <div className="w-14 h-14 bg-foret-600 text-white rounded-full flex items-center justify-center shadow-lg shadow-foret-200 border-4 border-white active:scale-95 transition-transform">
                <i className={`${item.icon} text-2xl`} />
              </div>
            ) : (
              <>
                <i className={`${item.icon} text-xl`} />
                <span className="text-[10px] font-medium mt-0.5">{item.label}</span>
              </>
            )}
            {item.primary && <span className="text-[10px] font-bold text-foret-600 mt-1">{item.label}</span>}
          </NavLink>
        )
      ))}
      </nav>
    </>
  );
};
